<template>
  <div>
    <Input
      @on-focus="openUser = true"
      :value="name"
      readonly
      placeholder="请选择"
      clearable
      @on-clear='$emit("clear")'
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openUser"
      draggable
      class="my-drawer"
      width='360'
    >
      <userTree :keyword='keyword' @user="reUser"></userTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name","placement","keyword"],
  data() {
    return {
      openUser: false,
    };
  },
  methods: {
    reUser(v) {
      this.openUser = false;
      this.$emit("update:id", v.id);
      this.$emit("update:account", v.account);
      this.$emit("update:accountId", v.accountId);
      this.$emit("update:name", v.name);
      this.$emit("user", v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectUser.vue